import { ThemeMode } from '@/core/store/uiState'

export enum SettingsItem {
  Theme = 'theme',
  RecentEdits = 'recent-edits',
  WhatsNew = 'whats-new',
  Diagnostics = 'diagnostics',
  Contact = 'contact',
}

export const SETTINGS_ITEMS = [
  SettingsItem.Theme,
  SettingsItem.RecentEdits,
  SettingsItem.WhatsNew,
  SettingsItem.Diagnostics,
  SettingsItem.Contact,
] as const

export const THEME_LABELS: Readonly<Record<ThemeMode, string>> = {
  [ThemeMode.Light]: 'Light',
  [ThemeMode.Dark]: 'Dark',
  [ThemeMode.System]: 'System',
}

export const THEME_MODES = [ThemeMode.Light, ThemeMode.Dark, ThemeMode.System] as const

export function validateSettingsConfiguration(): void {
  const configuredItems = new Set(SETTINGS_ITEMS)
  if (configuredItems.size !== SETTINGS_ITEMS.length
    || Object.values(SettingsItem).some((item) => !configuredItems.has(item))) {
    throw new Error('Settings item configuration must contain every item exactly once')
  }
  if (new Set(THEME_MODES).size !== THEME_MODES.length
    || Object.values(ThemeMode).some((mode) => !THEME_MODES.includes(mode))) {
    throw new Error('Settings theme configuration must contain every theme mode exactly once')
  }
  for (const mode of THEME_MODES) {
    if (!THEME_LABELS[mode].trim()) throw new Error(`Theme mode "${mode}" requires a Settings label`)
  }
}
